<template>
    <div id="body-wrap" class="">
        <LayoutHeader />
        <Covid />
        <Footer />
        <FooterPc />
        <Common />
    </div>
</template>

<script>
import LayoutHeader from '@/views/layout/LayoutHeader.vue';
import Footer from "@/views/layout/Footer";
import FooterPc from "@/views/layout/FooterPc";
import Covid from '@/views/covid/Covid.vue';
import Common from '@/views/common/Common.vue';

import { defualtMeta } from '@/confs/vue.meta';

export default {
    metaInfo: {
        meta: defualtMeta,
    },
    components: {
        LayoutHeader,
        Footer,
        FooterPc,
        Covid,
        Common,
    },
    created() {
        this.$store.dispatch('FETCH_COVID_GANGNAM_LIST');  // 강남구 코로나 현황
        this.$store.dispatch('FETCH_COVID_NATIONAL_LIST');  // 시도별 코로나 현황
        // this.$store.dispatch('FETCH_COVID_NATIONAL_SUM_LIST');  // 시도별 코로나 현황
    },
};
</script>
